import { render, staticRenderFns } from "./VlLog.vue?vue&type=template&id=8f22b3e0&scoped=true&"
import script from "./VlLog.vue?vue&type=script&lang=js&"
export * from "./VlLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f22b3e0",
  null
  
)

export default component.exports